import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

class SymptomLevel extends Component {

  render() {
    const { title, text, level, visible, available } = this.props;
    const visibleClasses = visible ? 'in' : '';
    const availableClasses = available ? '' : 'disabled';

    return (
      <div id={`booking-phase-symptoms-${level}`} className={`symptom-level collapse ${visibleClasses} ${availableClasses}`}>
        {title &&
          <div>
            <h2 tabIndex={0} id={`booking-phase-symptoms-${level}-title`} className="symptom-level-title">{title}</h2>
            <hr />
          </div>
        }
        { text &&
        <div className="symptom-level-text">
          <p>{text}</p>
        </div>
        }
        <div className="symptom-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

SymptomLevel.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  level: PropTypes.number.isRequired,
  visible: PropTypes.bool,
  available: PropTypes.bool,
  children: PropTypes.node
};

SymptomLevel.defaultProps = {
  text: null,
  visible: true,
  available: true,
  children: null
};

export default translate(['booking'])(SymptomLevel);



// WEBPACK FOOTER //
// ./src/components/SymptomLevel/SymptomLevel.jsx